<SimpleField {label} {required} {hints} {stacked}>

  {#if disabled}
    <Text px="sm" py="xs" color="body">{value}</Text>
  {/if}

  {#if !disabled}
    <Input 
      bind:value={value}
      {type} 
      {size} w={width}
      bg="white" 
      />
  {/if}
  
</SimpleField>

<script>
  import { Input, Text } from 'svelte-stylo'
  import SimpleField from './SimpleField.svelte'

  export let 
    label = '',
    required = null,
    type ='text',
    size = "100%",
    disabled = null,
    hints = null,
    stacked = false,
    value;

  let
    width = (size === '100%') ? size : null;

</script>
